/**
 * OnlyBuilds 5 — entry. Swap the mode in game/Game.ts (makeMode).
 */
import { Game } from "./game/Game";
import { boot } from "./ui/boot";

async function main() {
  const canvas = document.getElementById("game-canvas");
  if (!(canvas instanceof HTMLCanvasElement)) {
    throw new Error("#game-canvas missing");
  }

  await boot();

  const game = new Game(canvas);
  game.start();

  // Hot-reload friendly: expose for console tinkering during the build window
  (window as unknown as { __game: Game }).__game = game;
}

main().catch((err) => {
  console.error(err);
  const bootEl = document.getElementById("boot");
  if (bootEl) {
    bootEl.textContent = "Failed to boot — check console";
  }
});
